<div id="app-switcher" [class.app-switcher--spaces-switcher]="isSpacesSwitcherEnabled$ | async">
  <div class="switcher-organizations">
    <button type="button" class="app isSelected" [class.pencil]="!institutionLogo">
      <div class="picture" *ngIf="institutionLogo; else pencilLogo">
        <img [src]="institutionLogo" [alt]="user?.institution?.name" title="institution logo" />
      </div>
      <ng-template #pencilLogo>
        <svg-icon icon="PencilLogo"></svg-icon>
      </ng-template>
    </button>
  </div>
</div>
